import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/errors";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-md mx-auto w-full px-4 py-16">
        <Card className="tactile-card p-8 rounded-md" data-testid="forgot-password-card">
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676]">ACCOUNT RECOVERY</div>
          <h1 className="font-display text-3xl font-bold tracking-tight mt-2">Forgot your password?</h1>
          {sent ? (
            <div className="mt-6 flex gap-3 text-sm text-[#A0A7B0]" data-testid="forgot-password-sent">
              <MailCheck className="h-5 w-5 text-[#00E676] shrink-0" />
              <div>If <b className="text-[#F4F1EA]">{email}</b> has an account, a reset link is on its way. It works for 1 hour. Check spam if it doesn't show up.</div>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <p className="text-sm text-[#A0A7B0]">Enter your email and we'll send a one-time link to choose a new password.</p>
              <div>
                <Label htmlFor="email" className="text-xs text-[#A0A7B0]">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#0C0D0E] border-[#282C30] mt-1" data-testid="forgot-password-email" />
              </div>
              <Button type="submit" className="btn-emerald w-full h-11" disabled={loading} data-testid="forgot-password-submit">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          )}
          <div className="mt-6 text-sm text-[#A0A7B0] text-center">
            <Link to="/login" className="text-[#00E676] hover:underline" data-testid="forgot-password-back">Back to sign in</Link>
          </div>
        </Card>
      </div>
      <Footer />
    </div>
  );
}
